import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PortalModule } from './components/portal/portal.module';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, protectedResources } from '../services/auth.config';
// Services and Tokens
import { UiService } from '../services/ui.service';
import { HeaderService } from '../services/headerService';
import { BASE_URL } from './token'; 
import { ErrorComponent } from './components/shared/error/error.component';
import { GlobalHeaderComponent } from './components/shared/global-header/global-header.component';
import { PortalService } from '../services/portal.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { authHttpInterceptor } from './helpers/authHttpInterceptor';
import { SidebarComponent } from './components/shared/sidebar/sidebar.component';
import { EnrollmentModule } from './components/portal/pages/enrollment/enrollment.module';
import { GtmService } from '../services/gtm.service';
import { environment } from '../environments/environment';
import { TelemetryService } from '../services/telemetry.service';

export function initializeGtm(gtmService: GtmService) {
  return () => gtmService.initializeGtm();
}
@NgModule({
  declarations: [
    AppComponent,
    GlobalHeaderComponent,
    ErrorComponent,
    SidebarComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    PortalModule,
    EnrollmentModule,
    MsalModule.forRoot(new PublicClientApplication(msalConfig),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: protectedResources.todoListApi.scopes
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          [protectedResources.todoListApi.endpoint, protectedResources.todoListApi.scopes]
        ])
      })
  ],
  providers: [
    UiService,
    HeaderService,
    PortalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: authHttpInterceptor,
      multi: true,
    },
    GtmService,
    TelemetryService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGtm,
      deps: [GtmService],
      multi: true
    },
    MsalGuard,
    { provide: BASE_URL, useValue: environment.baseURL },  
  ],
  bootstrap: [AppComponent , MsalRedirectComponent]
})
export class AppModule { }
